import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { SearchState } from '../models/schemas.model';
import * as selectors from '../selectors/search.selectors';

@Injectable({ providedIn: 'root' })
export class SchemasSearchFacadeService extends FacadeService {
  constructor(public override store: Store<SearchState>) {
    super(store);
  }

  // OBSERVABLES
  nexus$ = this.storeSelect(selectors.getNexus);
  companies$ = this.storeSelect(selectors.getCompanies);
  levels$ = this.storeSelect(selectors.getLevels);
  taxOffices$ = this.storeSelect(selectors.getTaxOffices);
  redemptionTypes$ = this.storeSelect(selectors.getRedemptionTypes);
  countries$ = this.storeSelect(selectors.getCountries);
  panelExpanded$ = this.storeSelect(selectors.getPanelExpanded);
  sideNav$ = this.storeSelect(selectors.getSideNav);
  schemaCode$ = this.storeSelect(selectors.getSchemaCode);
  companyTitle$ = this.storeSelect(selectors.getCompanyTitle);
  vatNumber$ = this.storeSelect(selectors.getVATNumber);

  // OBSERVABLES VALUES
  get companies() {
    return this.storeSnapshot(this.companies$);
  }

  get levels() {
    return this.storeSnapshot(this.levels$);
  }

  get nexus() {
    return this.storeSnapshot(this.nexus$);
  }

  get countries() {
    return this.storeSnapshot(this.countries$);
  }

  get panelExpanded() {
    return this.storeSnapshot(this.panelExpanded$);
  }

  get schemaCode() {
    return this.storeSnapshot(this.schemaCode$);
  }

  get companyTitle() {
    return this.storeSnapshot(this.companyTitle$);
  }

  get vatNumber() {
    return this.storeSnapshot(this.vatNumber$);
  }
}
